import { Route, Outlet } from 'react-router-dom';
import { ProtectedRoute } from 'ProtectedRoute';
import { ForgotPasswordComponent } from './components/ForgotPasswordComponent';

export const FORGOT_PASSWORD_ROUTES = {
    FORGOT_PASSWORD: { path: '/forgot-password' },
};

export function configureForgotPasswordRoutes() {
    return [
        {
            routes: FORGOT_PASSWORD_ROUTES,
            config: {
                removeAppShell: true,
            },
        },
    ];
}

export function getForgotPasswordRoutes() {
    return (
        <Route id="forgot-password-routes" element={<Outlet />}>
            <Route
                path={FORGOT_PASSWORD_ROUTES.FORGOT_PASSWORD.path}
                element={
                    <ProtectedRoute accessPolicy="notLoggedIn">
                        <ForgotPasswordComponent />
                    </ProtectedRoute>
                }
            />
        </Route>
    );
}
